export const numberHasTwoDecimals = (inputValue) => {
  const decimalRegex = /^-?\d+(\.\d{1,2})?$/;

  return decimalRegex.test(inputValue);
}